import { ValidationResultEnum } from "../enums/ValidationResult";
import { IValidate } from "../../interfaces/IValidate";
import { inputResult } from "../helpers/inputResult";
import { ValidationResult } from "../helpers/ValidationResult";
import { IValidationProperties } from "../../interfaces/IValidationProperties";

export class TaxonomyValidator implements IValidate {
    validationProperties: IValidationProperties;
    constructor(validationProperties: IValidationProperties) {
        this.validationProperties = validationProperties;
    }

    validate(value): inputResult {
        const fieldHasNoSelectionButIsRequired = this.validationProperties.isRequired && (!value || !Array.isArray(value.terms) || value.terms.length == 0);
        if (fieldHasNoSelectionButIsRequired) {
            return this.handle({ inputResult: { error: "Field is required", value: (value || "") }, validationResult: ValidationResultEnum.FieldIsRequired });
        }

        return this.handle({ inputResult: { error: "", value: (value || "") }, validationResult: ValidationResultEnum.SuccessFull });
    }

    handle(result: ValidationResult): inputResult {
        switch (result.validationResult) {
            default: {
                return result.inputResult
            }
        }
    }
}